var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.758 12.5056C10.8362 12.4274 10.8362 12.3007 10.758 12.2225L6.65691 8.12139C6.26638 7.73087 6.26638 7.09771 6.65691 6.70718C7.04743 6.31666 7.6806 6.31666 8.07112 6.70718L13.0204 11.6565C13.4112 12.0472 13.4112 12.6808 13.0204 13.0716L8.07112 18.0209C7.6806 18.4114 7.04743 18.4114 6.65691 18.0209C6.26638 17.6304 6.26638 16.9972 6.65691 16.6067L10.758 12.5056Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.758 12.5056C16.8362 12.4274 16.8362 12.3007 16.758 12.2225L12.6569 8.12139C12.2664 7.73087 12.2664 7.09771 12.6569 6.70718C13.0474 6.31666 13.6806 6.31666 14.0711 6.70718L19.0204 11.6565C19.4112 12.0472 19.4112 12.6808 19.0204 13.0716L14.0711 18.0209C13.6806 18.4114 13.0474 18.4114 12.6569 18.0209C12.2664 17.6304 12.2664 16.9972 12.6569 16.6067L16.758 12.5056Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.442f3d2c97667ded102e4cfd74ab0b62.svg";
export { ForwardRef as ReactComponent };